import Header from "@components/Header/Header"
import JIDRInputCard from "@components/JIDRInputCard/JIDRInputCard"
import MerchantInformationDisplay from "@components/MerchantInformationDisplay/MerchantInformationDisplay"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import SectionLabel from "@components/SectionLabel/SectionLabel"
import { useNavigate } from "react-router"
import {
    Container,
    ContentContainer,
    InputContainer,
    ButtonContainer,
    InfoContainer,
    BoldText
} from "./PaymentLinkInputAmount.styles"
import { useNumericKeyboard } from "@hooks/useNumericKeyboard"
import { toCurrencyFormat } from "@lib/utils"
import { useEffect, useState } from "react"
import { MINIMUM_PAYMENT_LINK_AMOUNT } from "@constants/transaction"
import { useMerchantStore } from "@stores/merchantStore";
import { useTranslation } from "react-i18next";
import { setHeaderColor } from "@lib/telegram"
import { WHITE } from "@styles/colors"

const PaymentLinkInputAmount = () => {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { name, email, profilePictureUrl } = useMerchantStore();

    const { amount, handleKeyboardPress } = useNumericKeyboard(0)

    const [amountError, setAmountError] = useState({
        isError: false,
        message: ''
    })

    const validateAmount = () => {
        if (amount < MINIMUM_PAYMENT_LINK_AMOUNT) {
            setAmountError({
                isError: true,
                message: t('paymentLink.inputAmount.errorMessages.minimumAmount', { amount: toCurrencyFormat(MINIMUM_PAYMENT_LINK_AMOUNT) })
            })
        } else {
            setAmountError({
                isError: false,
                message: ''
            })
        }
    }

    useEffect(() => {
        setHeaderColor(WHITE)
    }, [])

    return (
        <Container>
            <Header title={t('paymentLink.inputAmount.header')} showBackButton onBackClick={() => navigate('/payment-link')} />
            <ContentContainer>
                <MerchantInformationDisplay 
                    title={name}
                    subtitle={email}
                    url={profilePictureUrl}
                />
                <InputContainer>
                    <SectionLabel>{t('paymentLink.inputAmount.quotationAmount')}</SectionLabel>
                    <JIDRInputCard
                        amount={amount}
                        title={t('paymentLink.inputAmount.inputAmount')}
                        isAmountError={amountError.isError}
                        onBlur={validateAmount}
                        errorText={amountError.message}
                        handleKeyboardPress={handleKeyboardPress}
                        children={<AdditionalInformation />}
                    />
                </InputContainer>
            </ContentContainer>
            <ButtonContainer>
                <PrimaryButton
                    disabled={amountError.isError || amount === 0}
                    onClick={() => navigate('/payment-link-summary', {
                        state: {
                            amount
                        }
                    })}
                >
                    {t('paymentLink.inputAmount.continueButton')}
                </PrimaryButton>
            </ButtonContainer>
        </Container>
    )
}

export default PaymentLinkInputAmount

const AdditionalInformation = () => {
    const { t } = useTranslation();
    return (
        <InfoContainer>
            <span>{t('paymentLink.inputAmount.additionalInfo.instruction')}</span>
            <span>
                {t('paymentLink.inputAmount.additionalInfo.conversionRate')} 
                <BoldText>
                    {t('paymentLink.inputAmount.additionalInfo.rate')}
                </BoldText>
            </span>
        </InfoContainer>
    )
}